import React from 'react';
import {ConfigApi, MultistoreLayoutType, OrderType, PlaceApi} from "../../../../../../../services/Api/types";
import {RootState} from "../../../../../../../../reducers";
import {connect} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {getSession} from "../../../../../../../services/Session/reducer";
import EmptyList from "../../../../../../../components/Common/EmptyList";
import {ReactComponent as PinIco} from "../../../../../../../../images/icons/pin-outline.svg"
import MultistorePlaceCard from "../../../../../components/PlaceCard/MultistorePlaceCard";
import ResponsiveComponent from "../../../../../../../components/Common/ResponsiveComponent";
import OrderTypesFilter from "../OrderTypesFilter/OrderTypesFilter";
import {getSortedPlacesByDistance} from "../../../../../utils/multistoreUtils";

interface OwnProps {
    places: PlaceApi[];
    setSelectedOrderType: React.Dispatch<React.SetStateAction<OrderType | undefined>>;
    selectedOrderType: OrderType | undefined;
    setHoveredPlace: React.Dispatch<React.SetStateAction<PlaceApi | undefined>>;
    setShowAddressModal: React.Dispatch<React.SetStateAction<boolean>>;
    config: ConfigApi;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistoreMapPagePlaceList = ({
                                        session,
                                        places,
                                        selectedOrderType,
                                        setSelectedOrderType,
                                        setHoveredPlace,
                                        setShowAddressModal,
                                        config
                                    }: Props) => {
    const {t} = useTranslation();
    const sortedPlaces = getSortedPlacesByDistance(places);

    const renderPlaces = (places: PlaceApi[], hover: boolean, withoutDeliveryInfo: boolean, preventClick?: boolean) => {
        return (
            <div className="places">
                {
                    places.map(place => (
                        <MultistorePlaceCard place={place} key={place.domain}
                                             setHoveredPlace={hover ? setHoveredPlace : undefined}
                                             preventOnClick={preventClick}
                                             selectedOrderType={selectedOrderType}
                                             withoutDeliveryInfo={withoutDeliveryInfo}
                                             layout={MultistoreLayoutType.HOME_WITH_MAP}
                                             config={config}
                                             setShowAddressModal={setShowAddressModal}
                        />
                    ))
                }
            </div>
        )
    };

    const getPlacesFilteredByOrderType = () => {
        return sortedPlaces.filter(place => !selectedOrderType ? place : place.types.includes(selectedOrderType));
    }

    const renderList = () => {
        const placesFilteredByOrderType = getPlacesFilteredByOrderType();

        if (selectedOrderType === OrderType.DELIVERY) {
            const placesInDeliveryZone = placesFilteredByOrderType.filter(place => place.in_delivery_zone);
            const placesOutsideDeliveryZone = placesFilteredByOrderType.filter(place => !place.in_delivery_zone);

            if (session.full_address) {
                return (
                    <div className="places-container">
                        <div>
                            <p className="places-heading">{`${t("modules.multistore.field.nearest_places.title")}:`}</p>
                            {
                                placesInDeliveryZone.length > 0 ? renderPlaces(placesInDeliveryZone, true, false) : (
                                    <EmptyList icon={<PinIco/>}
                                               title={t("modules.multistore.field.no_places_in_delivery_area.title")}/>
                                )
                            }
                        </div>
                        {
                            placesOutsideDeliveryZone.length > 0 && (
                                <div className="places-outside-delivery-zone-container">
                                    <p className="places-heading">{`${t("modules.multistore.field.places_outside_delivery_area.title")}:`}</p>
                                    {renderPlaces(placesOutsideDeliveryZone, false, true, true)}
                                </div>
                            )
                        }
                    </div>
                )
            }

            return (
                <div className="places-container">
                    {renderPlaces(placesFilteredByOrderType, true, false)}
                </div>
            )
        } else {
            if (session.full_address) {
                return (
                    <div className="places-container">
                        <p className="places-heading mb-0">{`${t("modules.multistore.field.nearest_places.title")}:`}</p>
                        {renderPlaces(placesFilteredByOrderType, true, false)}
                    </div>
                )
            }

            return (
                <div className="places-container">
                    {renderPlaces(placesFilteredByOrderType, true, false)}
                </div>
            )
        }
    };

    return (
        <div className="multistore-map-page-place-list">
            <ResponsiveComponent
                small={
                    <OrderTypesFilter selectedOrderType={selectedOrderType}
                                      setSelectedOrderType={setSelectedOrderType}
                                      setShowAddressModal={setShowAddressModal}
                    />
                }
                large={<></>}
                breakpoint={769}
            />
            {renderList()}
        </div>
    )
}
const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MultistoreMapPagePlaceList));
